"use strict";

exports.__esModule = true;
exports.NewLogbookTicketForm = void 0;
var _react = _interopRequireDefault(require("react"));
var _Core = require("../../Core");
var _getTranslatedTicketPriorities = require("../../Ticketing/getTranslatedTicketPriorities");
var _styledComponents = _interopRequireDefault(require("styled-components"));
var _core = require("@blueprintjs/core");
var _reactFinalForm = require("react-final-form");
var _reactIntl = require("react-intl");
var _finalFormArrays = _interopRequireDefault(require("final-form-arrays"));
var _DeviceListContext = require("../../Device/DeviceListContext");
var _DeviceTagListContext = require("../../Device/DeviceTagListContext");
var _DeviceSelector = require("../../Device/DeviceSelector");
var _DeviceTagSelector = require("../../Device/DeviceTagSelector");
var _FormGroupField = require("../../Form/FormGroupField");
var _TicketTypeSelector = require("../TicketTypeSelector");
var _ProfileContext = require("../../Profile/ProfileContext");
var _LogbookContext = require("../LogbookContext");
var _TicketingContext = require("../../Ticketing/TicketingContext");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _regenerator() { /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/babel/babel/blob/main/packages/babel-helpers/LICENSE */ var e, t, r = "function" == typeof Symbol ? Symbol : {}, n = r.iterator || "@@iterator", o = r.toStringTag || "@@toStringTag"; function i(r, n, o, i) { var c = n && n.prototype instanceof Generator ? n : Generator, u = Object.create(c.prototype); return _regeneratorDefine2(u, "_invoke", function (r, n, o) { var i, c, u, f = 0, p = o || [], y = !1, G = { p: 0, n: 0, v: e, a: d, f: d.bind(e, 4), d: function d(t, r) { return i = t, c = 0, u = e, G.n = r, a; } }; function d(r, n) { for (c = r, u = n, t = 0; !y && f && !o && t < p.length; t++) { var o, i = p[t], d = G.p, l = i[2]; r > 3 ? (o = l === n) && (u = i[(c = i[4]) ? 5 : (c = 3, 3)], i[4] = i[5] = e) : i[0] <= d && ((o = r < 2 && d < i[1]) ? (c = 0, G.v = n, G.n = i[1]) : d < l && (o = r < 3 || i[0] > n || n > l) && (i[4] = r, i[5] = n, G.n = l, c = 0)); } if (o || r > 1) return a; throw y = !0, n; } return function (o, p, l) { if (f > 1) throw TypeError("Generator is already running"); for (y && 1 === p && d(p, l), c = p, u = l; (t = c < 2 ? e : u) || !y;) { i || (c ? c < 3 ? (c > 1 && (G.n = -1), d(c, u)) : G.n = u : G.v = u); try { if (f = 2, i) { if (c || (o = "next"), t = i[o]) { if (!(t = t.call(i, u))) throw TypeError("iterator result is not an object"); if (!t.done) return t; u = t.value, c < 2 && (c = 0); } else 1 === c && (t = i["return"]) && t.call(i), c < 2 && (u = TypeError("The iterator does not provide a '" + o + "' method"), c = 1); i = e; } else if ((t = (y = G.n < 0) ? u : r.call(n, G)) !== a) break; } catch (t) { i = e, c = 1, u = t; } finally { f = 1; } } return { value: t, done: y }; }; }(r, o, i), !0), u; } var a = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} t = Object.getPrototypeOf; var c = [][n] ? t(t([][n]())) : (_regeneratorDefine2(t = {}, n, function () { return this; }), t), u = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(c); function f(e) { return Object.setPrototypeOf ? Object.setPrototypeOf(e, GeneratorFunctionPrototype) : (e.__proto__ = GeneratorFunctionPrototype, _regeneratorDefine2(e, o, "GeneratorFunction")), e.prototype = Object.create(u), e; } return GeneratorFunction.prototype = GeneratorFunctionPrototype, _regeneratorDefine2(u, "constructor", GeneratorFunctionPrototype), _regeneratorDefine2(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = "GeneratorFunction", _regeneratorDefine2(GeneratorFunctionPrototype, o, "GeneratorFunction"), _regeneratorDefine2(u), _regeneratorDefine2(u, o, "Generator"), _regeneratorDefine2(u, n, function () { return this; }), _regeneratorDefine2(u, "toString", function () { return "[object Generator]"; }), (_regenerator = function _regenerator() { return { w: i, m: f }; })(); }
function _regeneratorDefine2(e, r, n, t) { var i = Object.defineProperty; try { i({}, "", {}); } catch (e) { i = 0; } _regeneratorDefine2 = function _regeneratorDefine(e, r, n, t) { function o(r, n) { _regeneratorDefine2(e, r, function (e) { return this._invoke(r, n, e); }); } r ? i ? i(e, r, { value: n, enumerable: !t, configurable: !t, writable: !t }) : e[r] = n : (o("next", 0), o("throw", 1), o("return", 2)); }, _regeneratorDefine2(e, r, n, t); }
function asyncGeneratorStep(n, t, e, r, o, a, c) { try { var i = n[a](c), u = i.value; } catch (n) { return void e(n); } i.done ? t(u) : Promise.resolve(u).then(r, o); }
function _asyncToGenerator(n) { return function () { var t = this, e = arguments; return new Promise(function (r, o) { var a = n.apply(t, e); function _next(n) { asyncGeneratorStep(a, r, o, _next, _throw, "next", n); } function _throw(n) { asyncGeneratorStep(a, r, o, _next, _throw, "throw", n); } _next(void 0); }); }; }
var LogbookTicketFormContainer = _styledComponents["default"].div.withConfig({
  displayName: "NewLogbookTicketForm__LogbookTicketFormContainer",
  componentId: "sc-113r4jg-0"
})(["display:flex;flex:0 0 auto;height:100%;"]);
var DialogBodySection = _styledComponents["default"].div.withConfig({
  displayName: "NewLogbookTicketForm__DialogBodySection",
  componentId: "sc-113r4jg-1"
})(["margin:1rem 1rem 0 1rem;"]);
var validateDescription = function validateDescription(value) {
  if (!value || !value.trim()) {
    return /*#__PURE__*/_react["default"].createElement(_reactIntl.FormattedMessage, {
      id: "NewLogbookTicket.descriptionError",
      defaultMessage: "Description is required."
    });
  }
};
var validateTypes = function validateTypes(value) {
  if (!Array.isArray(value) || value.length === 0) {
    return /*#__PURE__*/_react["default"].createElement(_reactIntl.FormattedMessage, {
      id: "NewLogbookTicket.typeError",
      defaultMessage: "Type is required."
    });
  }
};
var validateDevices = function validateDevices(value) {
  if (!Array.isArray(value) || value.length === 0) {
    return /*#__PURE__*/_react["default"].createElement(_reactIntl.FormattedMessage, {
      id: "NewLogbookTicket.deviceError",
      defaultMessage: "Device is required."
    });
  }
};
var validatePriority = function validatePriority(value) {
  if (!value) {
    return /*#__PURE__*/_react["default"].createElement(_reactIntl.FormattedMessage, {
      id: "NewLogbookTicket.priorityError",
      defaultMessage: "Priority is required."
    });
  }
};
var NewLogbookTicketForm = exports.NewLogbookTicketForm = function NewLogbookTicketForm(props) {
  var _priorities$find;
  var onClose = props.onClose,
    showCancel = props.showCancel,
    useTicketingContext = props.useTicketingContext,
    filteredTicketTypes = props.filteredTicketTypes,
    ticketTypes = props.ticketTypes,
    device = props.device;
  var context = useTicketingContext ? _react["default"].useContext(_TicketingContext.TicketingContext) : _react["default"].useContext(_LogbookContext.LogbookContext);
  var _React$useContext = _react["default"].useContext(_Core.TranslatorContext),
    translate = _React$useContext.translate;
  var _React$useContext2 = _react["default"].useContext(_ProfileContext.ProfileContext),
    user = _React$useContext2.user;
  var deviceTags = _react["default"].useContext(_DeviceTagListContext.DeviceTagListContext);
  var devices = _react["default"].useContext(_DeviceListContext.DeviceListContext);
  var priorities = (0, _getTranslatedTicketPriorities.getTranslatedTicketPriorities)(translate);
  var _React$useState = _react["default"].useState(((_priorities$find = priorities.find(function (p) {
      return p.id === "Low";
    })) == null ? void 0 : _priorities$find.id) || "Low"),
    selectedPriority = _React$useState[0],
    setSelectedPriority = _React$useState[1];
  var handleSubmit = /*#__PURE__*/function () {
    var _ref = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee(values) {
      var _priorities$find2;
      var defaultPriorityId, output, _t;
      return _regenerator().w(function (_context) {
        while (1) switch (_context.p = _context.n) {
          case 0:
            defaultPriorityId = ((_priorities$find2 = priorities.find(function (priority) {
              return priority.id === translate("Medium");
            })) == null ? void 0 : _priorities$find2.id) || "Medium";
            output = {
              title: values.summary,
              description: "",
              devices: [].concat(values.devices.map(function (device) {
                return {
                  type: "UUID",
                  value: device.uuid
                };
              }), values.tags.map(function (tag) {
                return {
                  type: "TAG",
                  value: tag
                };
              })),
              type: values.types.map(function (type) {
                return type.id;
              }),
              status: "OPEN",
              creator: user,
              watchers: [],
              priority: values.priority || defaultPriorityId || "Medium"
            };
            _context.p = 1;
            _context.n = 2;
            return context.createNewTicket(output);
          case 2:
            if (onClose) {
              onClose();
            }
            _context.n = 4;
            break;
          case 3:
            _context.p = 3;
            _t = _context.v;
            console.error(_t);
          case 4:
            return _context.a(2);
        }
      }, _callee, null, [[1, 3]]);
    }));
    return function handleSubmit(_x) {
      return _ref.apply(this, arguments);
    };
  }();
  var ticketTypesGrouped = [].concat(filteredTicketTypes, ticketTypes);
  return /*#__PURE__*/_react["default"].createElement(LogbookTicketFormContainer, null, /*#__PURE__*/_react["default"].createElement(_reactFinalForm.Form, {
    initialValues: {
      types: [],
      devices: device ? [device] : [],
      tags: [],
      priority: selectedPriority
    },
    keepDirtyOnReinitialize: true,
    onSubmit: handleSubmit,
    mutators: Object.assign({}, _finalFormArrays["default"])
  }, function (_ref2) {
    var handleSubmit = _ref2.handleSubmit,
      pristine = _ref2.pristine,
      invalid = _ref2.invalid,
      submitting = _ref2.submitting;
    return /*#__PURE__*/_react["default"].createElement("form", {
      style: {
        width: "100%"
      },
      onSubmit: handleSubmit
    }, /*#__PURE__*/_react["default"].createElement(DialogBodySection, null, /*#__PURE__*/_react["default"].createElement(_FormGroupField.FormGroupField, {
      name: "types",
      label: /*#__PURE__*/_react["default"].createElement(_reactIntl.FormattedMessage, {
        id: "NewLogbookTicket.typeSelector",
        defaultMessage: "Types"
      }),
      validate: validateTypes
    }, function (_ref3) {
      var input = _ref3.input;
      return /*#__PURE__*/_react["default"].createElement(_TicketTypeSelector.TicketTypeSelector, _extends({
        usePortal: true,
        minimal: true,
        getItemCategory: function getItemCategory(item) {
          return filteredTicketTypes.includes(item) ? "Device" : "Other";
        }
      }, input, {
        getCategoryTitle: function getCategoryTitle(input) {
          return input;
        },
        items: ticketTypesGrouped,
        selected: input.value,
        onSelect: input.onChange
      }));
    }), /*#__PURE__*/_react["default"].createElement(_FormGroupField.FormGroupField, {
      name: "summary",
      label: /*#__PURE__*/_react["default"].createElement(_reactIntl.FormattedMessage, {
        id: "NewLogbookTicket.description",
        defaultMessage: "Summary"
      }),
      validate: validateDescription
    }, function (_ref4) {
      var input = _ref4.input;
      return /*#__PURE__*/_react["default"].createElement(_core.TextArea, _extends({
        "data-testid": "Summary",
        fill: true,
        style: {
          height: "100px"
        }
      }, input));
    }), /*#__PURE__*/_react["default"].createElement(_FormGroupField.FormGroupField, {
      name: "devices",
      label: /*#__PURE__*/_react["default"].createElement(_reactIntl.FormattedMessage, {
        id: "NewLogbookTicket.deviceSelector",
        defaultMessage: "Devices"
      }),
      validate: validateDevices
    }, function (_ref5) {
      var input = _ref5.input;
      return /*#__PURE__*/_react["default"].createElement(_DeviceSelector.DeviceSelector, _extends({
        usePortal: true,
        minimal: true,
        items: devices
      }, input, {
        selected: input.value,
        onSelect: input.onChange,
        multiple: true
      }));
    }), /*#__PURE__*/_react["default"].createElement(_FormGroupField.FormGroupField, {
      name: "tags",
      label: /*#__PURE__*/_react["default"].createElement(_reactIntl.FormattedMessage, {
        id: "NewLogbookTicket.groupSelector",
        defaultMessage: "Device Groups"
      })
    }, function (_ref6) {
      var input = _ref6.input;
      return /*#__PURE__*/_react["default"].createElement(_DeviceTagSelector.DeviceTagSelector, {
        usePortal: true,
        minimal: true,
        items: deviceTags,
        selected: input.value,
        onSelect: input.onChange,
        multiple: true
      });
    }), /*#__PURE__*/_react["default"].createElement(_FormGroupField.FormGroupField, {
      name: "priority",
      label: /*#__PURE__*/_react["default"].createElement(_reactIntl.FormattedMessage, {
        id: "NewLogbookTicket.priority",
        defaultMessage: "Priority"
      }),
      validate: validatePriority
    }, function (_ref7) {
      var input = _ref7.input;
      return /*#__PURE__*/_react["default"].createElement(_TicketTypeSelector.TicketTypeSelector, {
        items: priorities,
        selected: [priorities.find(function (_ref8) {
          var id = _ref8.id;
          return input.value === id;
        })],
        onSelect: function onSelect(_ref9) {
          var _ = _ref9[0],
            selectedPriority = _ref9[1];
          var newPriority = selectedPriority.id;
          setSelectedPriority(newPriority);
          input.onChange(newPriority);
        },
        dataTestId: "TicketTypeSelector-" + input.value
      });
    })), /*#__PURE__*/_react["default"].createElement("div", {
      className: _core.Classes.DIALOG_FOOTER
    }, /*#__PURE__*/_react["default"].createElement("div", {
      className: _core.Classes.DIALOG_FOOTER_ACTIONS
    }, showCancel ? /*#__PURE__*/_react["default"].createElement(_core.Button, {
      "data-testid": "LogbookTicketFormCancel",
      onClick: onClose,
      intent: _core.Intent.NONE,
      text: /*#__PURE__*/_react["default"].createElement(_reactIntl.FormattedMessage, {
        id: "Ticketing.Cancel",
        defaultMessage: "Cancel"
      })
    }) : null, /*#__PURE__*/_react["default"].createElement(_core.Button, {
      "data-testid": "LogbookTicketFormSubmit",
      type: "submit",
      intent: _core.Intent.PRIMARY,
      loading: submitting,
      text: /*#__PURE__*/_react["default"].createElement(_reactIntl.FormattedMessage, {
        id: "NewLogbookTicket.button",
        defaultMessage: "Create Ticket"
      }),
      disabled: pristine || invalid
    }))));
  }));
};